import { Base } from 'components/Containers/BaseContainer';
import { ToolbarContainer } from 'components/Containers/ToolbarContainer';
import SWTab from 'components/Layout/Tabs/SWTab';
import { TabList, TabPanel, Tabs } from 'react-tabs';
import { AssetListView } from './AssetView/AssetView';
import { DeviceListView } from './DeviceView/DeviceView';
import { TabletListView } from './TabletView/TabletView';
import { ExternalUserView } from './ExternalUserView/ExternalUserView';
import { OperatorListView } from './OperatorView/OperatorView';
import { MakeModelList } from './MakeModelView/components/MakeModelList';
import { useAppSelector } from 'store/hook';
import { isDarkTheme } from 'utils/theme';
import { useTranslation } from 'react-i18next';
import { CLIENT_THEME, clientThemePalette } from 'utils/clientTheme';

/**
 * Renders a tabbed view for managing entities.
 *
 * Current tabs:
 * - Users
 * - Assets
 * - Operator
 */
export const EntityManagementView = () => {
  const { t } = useTranslation();
  const theme = useAppSelector((state) => state.authReducer).customer.theme;
  const enableDarkTheme = isDarkTheme(theme);
  const palette = enableDarkTheme
    ? clientThemePalette[CLIENT_THEME].dark
    : clientThemePalette[CLIENT_THEME].light;

  return (
    <Base enableDarkTheme={enableDarkTheme}>
      <Tabs>
        <TabList style={{ borderBottomColor: palette.primary }}>
          <ToolbarContainer
            style={{
              paddingBottom: 0,
            }}
            enableDarkTheme={enableDarkTheme}
          >
            {/* BUG: The Permission tag causes MUI to detect the SWTab and create empty tab indexes */}
            <SWTab enableDarkTheme={enableDarkTheme}>{t('users')}</SWTab>
            <SWTab enableDarkTheme={enableDarkTheme}>{t('assets')}</SWTab>
            <SWTab enableDarkTheme={enableDarkTheme}>{t('operator')}</SWTab>
            <SWTab enableDarkTheme={enableDarkTheme}>{t('device')}</SWTab>
            <SWTab enableDarkTheme={enableDarkTheme}>{t('tablet')}</SWTab>
            <SWTab enableDarkTheme={enableDarkTheme}>{t('make_model')}</SWTab>
          </ToolbarContainer>
        </TabList>

        {/* USER LIST VIEW CONTENT */}
        {/* BUG: The Permission tag causes MUI to detect the SWTab and create empty tab indexes */}

        <TabPanel
          style={{
            padding: '11px 21px 21px',
          }}
        >
          <ExternalUserView />
        </TabPanel>

        {/* ASSET LIST VIEW CONTENT */}
        <TabPanel
          style={{
            padding: '11px 21px 21px',
          }}
        >
          <AssetListView />
        </TabPanel>

        {/* Operator LIST VIEW CONTENT */}
        <TabPanel
          style={{
            padding: '11px 21px 21px',
          }}
        >
          <OperatorListView />
        </TabPanel>

        {/* Device LIST VIEW CONTENT */}
        <TabPanel
          style={{
            padding: '11px 21px 21px',
          }}
        >
          <DeviceListView />
        </TabPanel>

        {/* Tablet LIST VIEW CONTENT */}
        <TabPanel
          style={{
            padding: '11px 21px 21px',
          }}
        >
          <TabletListView />
        </TabPanel>

        {/* Make Model LIST VIEW CONTENT */}
        <TabPanel
          style={{
            padding: '11px 21px 21px',
          }}
        >
          <MakeModelList />
        </TabPanel>
      </Tabs>
    </Base>
  );
};
